module.exports = __webpack_public_path__ + "img/macStep3_1.6741bd8a.png";